import { combineReducers } from "@reduxjs/toolkit"
import authReducer from "../features/auth/authSlice"
import orderReducer from "../features/order/orderSlice"

const rootReducer = combineReducers({
  auth: authReducer,
  order: orderReducer
})

export default rootReducer